var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "120px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "场次名称", prop: "itemName" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "100%" },
                        attrs: { clearable: "" },
                        model: {
                          value: _vm.childData.itemName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "itemName", $$v)
                          },
                          expression: "childData.itemName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "每个用户可报名人数（人）",
                        prop: "maxRegNum"
                      }
                    },
                    [
                      _c("el-input-number", {
                        staticStyle: { width: "100%" },
                        attrs: { min: 0, max: 999999, precision: 0 },
                        model: {
                          value: _vm.childData.maxRegNum,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "maxRegNum", $$v)
                          },
                          expression: "childData.maxRegNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "所属剧院", prop: "theaterId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择所属剧院"
                          },
                          model: {
                            value: _vm.childData.theaterId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "theaterId", $$v)
                            },
                            expression: "childData.theaterId"
                          }
                        },
                        _vm._l(_vm.theaterOption, function(item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.name, value: item.id }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [_vm._v("取消")]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v("确定")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }